export const firebaseRef = {
  MESSAGES: 'MESSAGES',
  CHANNELS: 'CHANNELS',
  USERS: 'USERS',
  FAVORITES: 'FAVORITES',
}